import { pitDataQueryOptions } from '@/api/pit/getters';
import Layout from '@/components/layouts/Layout';
import { ERROR_MESSAGES, WebsiteType } from '@/consts';
import { CaseCardVariants } from '@/features/v2/MobileMenu';

import { PitDownloadCard } from './PitDownloadCard';
import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router-dom';

export const AppLoaderPit =
  (queryClient: QueryClient) => async (props: LoaderFunctionArgs) => {
    const { params } = props;
    const id = params?.id as string;

    try {
      const query = pitDataQueryOptions(id);
      const data = await queryClient.ensureQueryData(query);

      return data;
    } catch (e) {
      if (e instanceof Response) {
        throw e;
      }

      throw new Response(ERROR_MESSAGES.API_DOWN, {
        status: 503,
      });
    }
  };

const AppCaseCard = () => {
  return (
    <Layout
      withoutProgress
      caseCard
      variant={WebsiteType.HELPFIND}
      navbarProps={{
        disableMobileMenu: true,
        caseCardVariant: CaseCardVariants.EMPTY,
        phone: '616 350 050',
      }}
      className="[&>main>div]:space-y-10 [&>main>div]:lg:space-y-10 [&>main]:pb-[60px] [&>main]:lg:pt-[30px]"
    >
      <PitDownloadCard />
    </Layout>
  );
};

export default AppCaseCard;
